import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'antd/lib/icon';
import Upload from 'antd/lib/upload';
import message from 'antd/lib/message';
import { translate } from 'react-i18next';

const { Dragger } = Upload;

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

const DocumentUpload = ({ uploadedFilesList, onUpload, onRemove, t }) => {
  const beforeUpload = (file) => {
    if (file.size > MAX_FILE_SIZE) {
      message.error(
        t('Súbor je príliš veľký. Maximálna povolená veľkosť je 10 MB.'),
        5
      );
      return false;
    }
    return true;
  };

  return (
    <Dragger 
      fileList={uploadedFilesList} 
      customRequest={onUpload} 
      onRemove={onRemove} 
      beforeUpload={beforeUpload}
      multiple
    >
      <p className="ant-upload-drag-icon">
        <Icon type="inbox" />
      </p>
      <p className="ant-upload-text">
        {t('Kliknutím alebo pretiahnutím vyberte súbory pre nahratie.')}
      </p>
    </Dragger>
  );
};

DocumentUpload.propTypes = {
  t: PropTypes.func.isRequired,
  uploadedFilesList: PropTypes.array.isRequired,
  onUpload: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default translate()(DocumentUpload);



// WEBPACK FOOTER //
// ./src/features/account-management/components/documents/DocumentUpload.js